export default function ({ store }) {
  // Only run on client-side
  if (process.client) {
    // Set initial width
    store.commit('SET_WINDOW_WIDTH', window.innerWidth)

    // Add resize event listener
    window.addEventListener('resize', () => {
      store.commit('SET_WINDOW_WIDTH', window.innerWidth)
    })
  }
}
